import styled from "styled-components";

interface IContainer {
  checked?: any;
  hasError?: any;
  height?: string;
  width?: string;
}
export const Container = styled.div<IContainer>`
  ${(props) => `
    background-color: ${
      props.checked ? props.theme.colors.white : props.theme.colors.gray72
    };
    border: ${
      props.hasError ? "solid 1px " + props.theme.colors.accentRed : "none"
    };
    height: ${props.height ? props.height : "4.5rem"};
    width: ${props.width};
  `}
  align-items: center;
  box-shadow: 0rem 0.5rem 2rem rgba(231, 231, 234, 0.62);
  box-sizing: border-box;
  border-radius: 0.8rem;
  display: flex;
  padding: 1rem;

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const InputSection = styled.input`
  ${(props) => `
    background-color: ${
      props.checked ? props.theme.colors.white : props.theme.colors.gray72
    };
    color: ${props.theme.colors.blackTextTitle};
    cursor: ${props.checked ? "text" : "default"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    
  `}
  border: none;
  font-size: 1.5rem;
  font-weight: 500;
  outline: none;
  width: 100%;
`;

export const CheckboxSection = styled.input`
  cursor: pointer;
  outline: none;
`;
